export enum UserStatus {
  LEGACY = 'LEGACY',
  NEW = 'NEW',
  VERIFIED = 'VERIFIED',
}
